import React from 'react';
import { Box, Button, Dialog, DialogContent, IconButton, Typography, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { siteColor } from '../projectSchedule.utils';
import VisitPanel from '../schedule/VisitPanel';
import TicketCard from './TicketCard';
import { buttonStyles } from '../../../theme/formStyles';

// A ticket visit opened from the calendars: the ticket and its check-in / report panel
export default function TicketVisitDialog({ item, currentUserId, onClose, onChanged, onOpenTickets }) {
    const fullScreen = useMediaQuery('(max-width:700px)');
    if (!item) return null;
    return (
        <Dialog open onClose={onClose} fullWidth maxWidth="xs" fullScreen={fullScreen} PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 4 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2.25, py: 1.75, bgcolor: siteColor(item.facility_id), color: '#fff' }}>
                <Typography sx={{ fontWeight: 700, flex: 1, minWidth: 0 }} noWrap>🎫 {item.facility_name}</Typography>
                <IconButton size="small" onClick={onClose} aria-label="Close" sx={{ color: '#fff' }}><CloseIcon /></IconButton>
            </Box>
            <DialogContent sx={{ pt: 2 }}>
                {item.ticket && <TicketCard ticket={item.ticket} />}
                <VisitPanel key={item.key} task={item} currentUserId={currentUserId} onChanged={onChanged} />
                {onOpenTickets && (
                    <Box sx={{ mt: 2 }}>
                        <Button fullWidth variant="outlined" onClick={() => { onClose(); onOpenTickets(item); }} sx={buttonStyles.outlined}>Open in Tickets (assign / resolve)</Button>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}
